import {getConversationMessage} from "@/Services/conversation-messages";

export default ($user, conversation, messages, toast, router, getConversation) => {
    return [
        {
            event: "Conversations\\ConversationMessageSent",
            callback: async (event: any) => {
                console.log("ConversationMessageSent", event);
                if (conversation.value && event.conversation === conversation.value.id && event.sender !== $user.id) {
                    try {
                        const {data} = await getConversationMessage(conversation.value.id, event.message);
                        messages.value.push(data);
                    } catch (error) {
                        console.log(error);
                    }
                }
            },
        },
        {
            event: "Conversations\\ConversationParticipantsAdded",
            callback: (event: any) => {
                console.log("ConversationParticipantsAdded", event);
                if (conversation.value && event.conversation === conversation.value.id) {
                    getConversation();
                }
            },
        },
        {
            event: "Conversations\\ConversationParticipantRemoved",
            callback: (event: any) => {
                console.log("ConversationParticipantRemoved", event);
                if (conversation.value && event.conversation === conversation.value.id) {
                    if ($user.id === event.participant) {
                        toast.add({
                            severity: "error",
                            summary: "Removed",
                            detail: "You have been removed from this conversation",
                            life: 3000,
                        });
                        router.replace({name: "conversations.index"});
                    } else {
                        getConversation();
                    }
                }
            },
        },
        {
            event: "Conversations\\ConversationMessageDeleted",
            callback: (event: any) => {
                console.log("ConversationMessageDeleted", event);
                if (conversation.value && event.conversation === conversation.value.id) {
                    messages.value = messages.value.filter((M) => M.id !== event.message);
                }
            },
        },
    ];
};
